import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import UserDashboard from './pages/UserDashboard';
import MechanicDashboard from './pages/MechanicDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AuthNavbar from './components/AuthNavbar'; // Import the new AuthNavbar
import Footer from './components/Footer';

// --- INLINE PAGES FOR QUICK SETUP ---
// Note: These now use AuthNavbar for a cleaner look

const AboutUs = () => (
  <>
    <AuthNavbar />
    <div className="container" style={{ minHeight: '70vh' }}>
      <div className="card" style={{ marginTop: '2rem' }}>
        <h2 style={{ color: '#007bff' }}>About OnRoad Assist</h2>
        <p>OnRoad Assist is a specialized emergency vehicle assistance platform developed as a final year project by <strong>Shashank Shashu</strong> and <strong>Arjun D</strong>.</p>
        <p>We are 6th-semester BCA students at <strong>Spurthy College of Science and Management Studies</strong>. Our goal is to bridge the gap between stranded motorists and professional mechanics using real-time GPS tracking and instant communication.</p>
        <hr />
        <h4>Our Technology</h4>
        <p>This project is built using the MERN Stack (MongoDB, Express, React, Node.js) and utilizes Leaflet.js for open-source map integration.</p>
      </div>
    </div>
    <Footer />
  </>
);

const ContactUs = () => (
  <>
    <AuthNavbar />
    <div className="container" style={{ minHeight: '70vh' }}>
      <div className="card" style={{ marginTop: '2rem', textAlign: 'center' }}>
        <h2 style={{ color: '#007bff' }}>Contact Us</h2>
        <p>Have questions or need technical support regarding the app?</p>
        <div style={{ margin: '2rem 0' }}>
          <h3>📞 Phone</h3>
          <p style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>+91 90194 99599</p>
          <br />
          <h3>📧 Email</h3>
          <p style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Shashankshashu515@gmail.com</p>
          <br />
          <h3>📍 Location</h3>
          <p>Spurthy College of Science and Management Studies,<br />Marasur Gate, Anekal Main Road, Bangalore.</p>
        </div>
      </div>
    </div>
    <Footer />
  </>
);

const Terms = () => (
  <>
    <AuthNavbar />
    <div className="container" style={{ minHeight: '70vh' }}>
      <div className="card" style={{ marginTop: '2rem' }}>
        <h2 style={{ color: '#007bff' }}>Terms & Conditions</h2>
        <ol style={{ lineHeight: '2' }}>
          <li><strong>Service Nature:</strong> OnRoad Assist is a platform connecting users with third-party mechanics. We do not personally provide repair services.</li>
          <li><strong>User Data:</strong> By using the "Locate Me" feature, you consent to sharing your GPS coordinates with the assigned mechanic.</li>
          <li><strong>Safety:</strong> In case of life-threatening emergencies or accidents, users are advised to use the SOS button to call official emergency services (112) immediately.</li>
          <li><strong>Accountability:</strong> Mechanics are responsible for the quality of their repairs and their individual pricing.</li>
        </ol>
      </div>
    </div>
    <Footer />
  </>
);

// --- MAIN APP COMPONENT ---

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/user-dashboard" element={<UserDashboard />} />
          <Route path="/mechanic-dashboard" element={<MechanicDashboard />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          
          {/* New Routes */}
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;